import { Box, Container, Typography } from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';

function AboutPage() {
  return (
    <Box 
      sx={{ 
        bgcolor: '#000000',
        minHeight: '100vh',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowX: 'hidden'
      }}
    >
      <Header />
      <Box
        sx={{
          pt: '84px',
          pb: '100px'
        }}
      >
        <Container 
          maxWidth="md"
          sx={{
            color: 'white',
            p: { xs: 2, sm: 4 }
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            sx={{
              color: '#ff0000',
              fontWeight: 600,
              mb: 4,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              textShadow: '0 0 10px rgba(255, 0, 0, 0.3)'
            }}
          >
            About Screamify™
          </Typography>

          <Typography
            variant="h5"
            sx={{
              mb: 4,
              color: '#ff0000',
              opacity: 0.9,
              fontWeight: 500
            }}
          >
            Unleashing the Future of Independent Horror
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8 }}>
              Screamify™ is revolutionizing the horror streaming landscape by breaking down the traditional barriers of Hollywood gatekeeping. We're building a platform that puts independent horror filmmakers first, creating a space where innovative, daring, and unique voices in horror can thrive.
            </Typography>

            <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8 }}>
              With our recent $500,000 seed funding, we're developing a state-of-the-art streaming platform accessible across web, iOS, Android, Apple TV, Roku, and Amazon Fire Stick. This investment marks the beginning of our mission to democratize horror entertainment.
            </Typography>

            <Typography variant="h6" sx={{ color: '#ff0000', mt: 2 }}>
              Our Mission
            </Typography>

            <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8 }}>
              We believe in making horror accessible to everyone. At just $4.99 per month, we're keeping subscriptions affordable while ensuring that a significant portion of our revenue goes directly into funding new independent horror productions. Unlike traditional streaming services, our focus isn't on profit margins – it's on fostering the next generation of horror filmmaking talent.
            </Typography>

            <Typography variant="h6" sx={{ color: '#ff0000', mt: 2 }}>
              What Sets Us Apart
            </Typography>

            <Box component="ul" sx={{ mt: 1, pl: 3 }}>
              <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
                Annual Horror Film Festival showcasing the best in independent horror
              </Typography>
              <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
                Online contests featuring cutting-edge AI filmmaking in horror
              </Typography>
              <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
                Direct funding for independent horror film productions
              </Typography>
              <Typography component="li" sx={{ mb: 2, opacity: 0.9 }}>
                Platform for undiscovered horror filmmakers to reach a dedicated audience
              </Typography>
            </Box>

            <Typography variant="h6" sx={{ color: '#ff0000', mt: 2 }}>
              Current Initiatives
            </Typography>

            <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8 }}>
              We're actively seeking unique, never-before-streamed horror films to license. Our team is building a diverse library of content that pushes the boundaries of the genre while providing opportunities for emerging filmmakers to showcase their work.
            </Typography>

            <Typography variant="body1" sx={{ opacity: 0.9, lineHeight: 1.8, mt: 2 }}>
              By leveraging automation and maintaining a lean operational model, we ensure that more resources go directly into content creation and filmmaker support. This approach allows us to keep subscription costs low while maximizing our impact on the independent horror community.
            </Typography>
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}

export default AboutPage; 